import { useQuery } from '@tanstack/react-query';

import { ListVoucherLogsQuery, listVoucherLogs } from '~/services/PromoService';

type Params = {
  query?: ListVoucherLogsQuery;
  enabled?: boolean;
};

export function useListVoucherLogs({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: ['voucher-logs', query],
    queryFn: async () => {
      return await listVoucherLogs(query ?? {});
    },
    enabled: enabled && query !== undefined,
  });
}
